import format from 'date-fns/format'
import isValidDate from '@utils/is-valid-date'

export default function formatTime(date) {
    if (!isValidDate(date)) return false
    return format(date, ['h:mm a'])
}
